<ngx-spinner [name]="'adicionar-credito'" type="ball-clip-rotate-pulse" [fullScreen]="false"
  bdColor="rgba(0, 0, 0, 0.2)"></ngx-spinner>
<mat-card>
  <mat-card-header>
    <mat-card-title>Adicionar Crédito</mat-card-title>
  </mat-card-header>
  <mat-divider></mat-divider>

  <mat-card-content *ngIf="bConsulta">
    <div class="row">
      <div class="col-sm">
        <mat-form-field appearance="outline" [floatLabel]="'always'">
          <mat-label>Filtro</mat-label>
          <input matInput (keyup)="aplicarFiltroTabela($event)" placeholder="Filtro">
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-sm">
        <table mat-table [dataSource]="clientesSource" class="mat-elevation-z2" style="width: 100%;">

          <ng-container matColumnDef="Nome">
            <th mat-header-cell *matHeaderCellDef> Nome </th>
            <td mat-cell *matCellDef="let element"> {{element.Nome}} </td>
          </ng-container>

          <ng-container matColumnDef="CPFCNPJ">
            <th mat-header-cell *matHeaderCellDef> CPF / CNPJ </th>
            <td mat-cell *matCellDef="let element"> {{element.CPFCNPJ}} </td>
          </ng-container>

          <ng-container matColumnDef="Cidade">
            <th mat-header-cell *matHeaderCellDef> Cidade </th>
            <td mat-cell *matCellDef="let element"> {{element.Cidade}} </td>
          </ng-container>

          <ng-container matColumnDef="Estado">
            <th mat-header-cell *matHeaderCellDef> Estado </th>
            <td mat-cell *matCellDef="let element"> {{element.UF}} </td>
          </ng-container>

          <ng-container matColumnDef="Status">
            <th mat-header-cell *matHeaderCellDef> Status </th>
            <td mat-cell *matCellDef="let element"> {{element.StatusString}} </td>
          </ng-container>

          <ng-container matColumnDef="DataUltimoVoucherCreditado">
            <th mat-header-cell *matHeaderCellDef> Data último voucher </th>
            <td mat-cell *matCellDef="let element"> {{element.DataUltimoVoucherCreditado}} </td>
          </ng-container>

          <ng-container matColumnDef="Voucher">
            <th mat-header-cell *matHeaderCellDef> Voucher (Crédito) </th>
            <td mat-cell *matCellDef="let element">R$ {{element.TotalVoucher.toFixed(2).replace('.',',')}} </td>
          </ng-container>

          <ng-container matColumnDef="Historico">
            <th mat-header-cell *matHeaderCellDef> Historico </th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button matTooltip="Detalhar histórico" (click)="historicoCliente(element)"
                class="iconbutton" color="primary">
                <mat-icon aria-label="Expandir">search</mat-icon>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="AdicionarCreditoVoucher">
            <th mat-header-cell *matHeaderCellDef> Adicionar crédito </th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button matTooltip="Adicionar crédito" (click)="adicionarCredito(element)"
                class="iconbutton" color="primary">
                <mat-icon aria-label="Expandir">add</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          <!-- Row shown when there is no matching data that will be provided to the wrapper table. -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="8" style="text-align: center;">Nenhum dado foi encontrado
            </td>
          </tr>
        </table>

        <mat-paginator [pageSizeOptions]="[10, 15, 20, 25]"></mat-paginator>
      </div>
    </div>
  </mat-card-content>
</mat-card>
